import React from 'react';
import { Text, StyleSheet } from 'react-native';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
// False negative PropType warnings are a headache in dev
// @ts-ignore
Icon.propTypes = undefined;
// @ts-ignore
Text.propTypes = global.__ENABLE_PROPTYPES__ ? Text.propTypes : undefined;
const IconWrapper = (props) => {
    const { name, style } = props;
    const { height, ...iconStyle } = StyleSheet.flatten(style ?? {});
    // UI Kitten button expects Icons to be an <Image> (where tintColor is valid)
    // Since we're using a 3rd party adapter, it renders as <Text> component
    // So we can map tintColor -> color to achieve the same thing
    // @ts-ignore
    const convertTintToColor = iconStyle.tintColor
        // @ts-ignore
        ? { color: iconStyle.color || iconStyle.tintColor }
        : {};
    return (<Icon name={name} size={height} 
    // @ts-ignore
    style={[iconStyle, convertTintToColor]}/>);
};
const IconProvider = (name) => ({
    toReactElement: (props) => IconWrapper({ name, ...props }),
});
function createIconsMap() {
    return new Proxy({}, {
        get(target, name) {
            return IconProvider(name);
        },
    });
}
export const IconPack = {
    name: 'materialCommunity',
    icons: createIconsMap(),
};
export default IconPack;
//# sourceMappingURL=adapter.js.map